<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter101">
<p class="centerImage"><img alt="images" id="img1" src="images/img1.jpg"/></p>
<h2 class="caption">The author’s father poses proudly next to ‘Schnauferl’ ready to set off on the expedition to the Saarland. The author is on the balcony behind (second left).</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LuftwaffeFighterPilot_ch101.vue?7805bcb2